const styles = theme => ({
  root: {
    marginTop: 12,
  },
  button: {
    fontSize: 12,
    width:40,
    height:25,
    marginTop: 24,
    marginBottom: 12,
  },
  emptySpace: {
    marginBottom:6,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/SavedSearches/components/RowDetails/styles.js